import { useEffect } from "react";

const SITIO = "https://www.salvir.com";

// Busca una etiqueta <meta>; si no existe la crea, y le pone el contenido
function ponerMeta(atributo, nombre, contenido) {
  let etiqueta = document.head.querySelector(`meta[${atributo}="${nombre}"]`);
  if (!etiqueta) {
    etiqueta = document.createElement("meta");
    etiqueta.setAttribute(atributo, nombre);
    document.head.appendChild(etiqueta);
  }
  etiqueta.setAttribute("content", contenido);
}

// Le dice a Google cuál es la dirección oficial de esta página
function ponerCanonical(url) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

// Cada página pública lo usa así:
// useSEO({ titulo: "...", descripcion: "...", ruta: "/seguridad" })
export default function useSEO({ titulo, descripcion, ruta }) {
  useEffect(() => {
    const url = SITIO + ruta;
    document.title = titulo;
    ponerMeta("name", "description", descripcion);
    ponerMeta("property", "og:title", titulo);
    ponerMeta("property", "og:description", descripcion);
    ponerMeta("property", "og:url", url);
    ponerCanonical(url);
  }, [titulo, descripcion, ruta]);
}